const validateIban = (ibanInputNumber: string): boolean => {
  if (!/^\d{24}$/.test(ibanInputNumber)) {
    return false;
  }

  const iban = `IR${ibanInputNumber}`;

  // Move first four characters to the end.
  const rearranged = `${iban.slice(4)}${iban.slice(0, 4)}`;

  // Convert letters to numbers.
  const numericIban = rearranged.replace(/[A-Z]/g, char =>
    (char.charCodeAt(0) - 55).toString(),
  );

  // Calculate MOD-97 without converting the whole value to Number.
  let remainder = 0;

  for (const digit of numericIban) {
    remainder = (remainder * 10 + Number(digit)) % 97;
  }

  return remainder === 1;
};

export default validateIban;
